import { Fragment, Component } from 'react';
import cx from 'classnames';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { bool, string, shape } from 'prop-types';
import { MyBoxProvider, MyBoxStatus } from '@fff-web/fff-box';
import { boxExpired } from '../../utils/boxStatus';
import ExpandDetails from './ExpandDetails/ExpandDetails';
import './Header.css';
import { args } from './headerArgs';
import ReactivateSubscription from './ReactivateSubscription/ReactivateSubscription';
import ReferAFriend from './ReferAFriend/ReferAFriend';
import UpgradeMembership from './UpgradeMembership/UpgradeMembership';

class Header extends Component {
  static defaultProps = {
    showGrowthReactivatePopUp: false,
    sysdata: {
      isMobile: false,
      boxData: {
        season: {},
        currentBox: {},
        boxItems: {},
        boxAddons: {},
        shiplist: [],
      },
    },
    boxStatusDesc: {
      EXPIRED: "Looks like you won't be getting this box!",
      NO_BOX: 'Your order has not yet been processed',
      PAST_SEASON: 'Your Box has arrived!',
      PRE_PROCESSING: 'Your order has not yet been processed',
      PROCESSING: 'Your order has been saved.',
      ASSIGNED: 'Your box is getting ready to ship.',
      DELIVERED: 'Your order has been delivered',
      PROBABLY_DELIVERED: 'Your order has shipped',
      SHIPPED: 'Your order has shipped',
    },
    reactivateTitle: 'Reactivate your Subscription',
    reactivateDescription:
      'Become an active member today to regain access to add-ons, sales and box customizations.',
    reactivateCTA: 'Reactivate Now',
    upgradeTitle: 'Want More Perks?',
    upgradeDescription:
      'Upgrade to Select to get earlier shipping, more box customization, early access to sales and more!',
    upgradeCTA: 'upgrade now',
    referCTA: 'GET $15',
    referTitle: 'Refer Friends & Earn Credit',
    referDescription: 'Refer your friends and get $15 towards your next purchase when they join.',
    flags: {},
    hideContent: true,
    isProductSubscription: false,
  };

  state = {
    detailsExpanded: false,
  };

  toggleExpand = () => {
    this.setState({ detailsExpanded: !this.state.detailsExpanded });
  };

  render() {
    const {
      boxStatusDesc,
      referCTA,
      referDescription,
      referTitle,
      sysdata,
      reactivateCTA,
      reactivateDescription,
      reactivateTitle,
      upgradeCTA,
      upgradeDescription,
      upgradeTitle,
      showGrowthReactivatePopUp,
      flags,
      hideContent,
      isProductSubscription,
    } = this.props;

    const { boxData, isMobile, userData } = sysdata;
    const isSelect = userData ? userData.select : false;
    const isExpired = boxExpired(userData);

    const rowStyle = cx({
      'flex-fdc': isMobile,
      'flex-aic': isMobile,
      'd-flex': true,
      'w-100': true,
      'flex-jsb': !isMobile,
      'ta-center': isMobile,
    });

    const titleStyles = cx({
      'my-box-page-title': true,
      'mar-0': true,
      'pad-0': true,
      'ff-pds': true,
      'fw-nor': true,
      'ta-center': isMobile,
    });

    return (
      <div className="fw-400 ff-ns">
        <h1 className={titleStyles}>My Subscriptions</h1>
        <div className="hor-rule" />
        {!hideContent && (
          <Fragment>
            {flags.wizmoHomepage ? (
              <MyBoxProvider>
                <MyBoxStatus
                  flags={flags}
                  showAddressDetails
                  RightContent={() => (
                    <ReferAFriend title={referTitle} desc={referDescription} cta={referCTA} />
                  )}
                />
              </MyBoxProvider>
            ) : (
              <div className={rowStyle}>
                {/* Move to it's own file */}
                {/* Toggle on Mobile */}
                {isMobile && (
                  <ExpandDetails
                    expired={isExpired}
                    boxStatusDesc={boxStatusDesc}
                    expanded={this.state.detailsExpanded}
                    onClick={this.toggleExpand}
                    boxData={boxData}
                  />
                )}

                {isMobile && <div className="hor-rule mar-h-8" />}

                {!isExpired && !isProductSubscription && !isSelect && (
                  <UpgradeMembership
                    title={upgradeTitle}
                    desc={upgradeDescription}
                    cta={upgradeCTA}
                  />
                )}

                {isExpired && (
                  <ReactivateSubscription
                    title={reactivateTitle}
                    desc={reactivateDescription}
                    cta={reactivateCTA}
                    showGrowthReactivatePopUp={showGrowthReactivatePopUp}
                  />
                )}
              </div>
            )}
          </Fragment>
        )}
      </div>
    );
  }
}

export default withLDConsumer()(Header);

Header.propTypes = {
  showGrowthReactivatePopUp: bool,
  sysdata: shape({
    isMobile: bool,
    userData: shape({
      select: bool,
    }),
    boxData: shape({}),
  }),
  boxStatusDesc: shape({
    EXPIRED: string,
    NO_BOX: string,
    PAST_SEASON: string,
    PRE_PROCESSING: string,
    PROCESSING: string,
    ASSIGNED: string,
    DELIVERED: string,
    PROBABLY_DELIVERED: string,
    SHIPPED: string,
  }),
  reactivateTitle: string,
  reactivateDescription: string,
  reactivateCTA: string,
  upgradeTitle: string,
  upgradeDescription: string,
  upgradeCTA: string,
  referCTA: string,
  referTitle: string,
  referDescription: string,
  flags: shape({
    wizmoHomepage: bool,
  }),
  hideContent: bool,
  isProductSubscription: bool,
};

Header.args = args;
